import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="company-forms"
export default class extends Controller {
  connect() {}

  async companyNameUniqueness(event) {
    const input = event.target;
    const value = input.value;
    if(input.value === '') {
      document.querySelector('input[type="submit"]').removeAttribute('disabled')
      return
    }
    const url = `${event.params.url}?company_name=${value}`;
    
    const response = await fetch(url)
    const json = await response.json()
    if(json.alreadyExists){
      document.querySelector('input[type="submit"]').disabled = true
      const div = document.createElement('div')
      div.classList.add('field-error');
      div.id = "error-duplicate-name"

      const innerDiv = document.createElement('div');
      innerDiv.textContent = "Relation already exists ";

      if(json.path && json.path !== '') {
        const link = document.createElement('a');
        link.href = json.path;
        link.textContent = "Click to open";
        innerDiv.appendChild(link);
      }

      div.appendChild(innerDiv);
      input.insertAdjacentElement('afterend', div);
    } else {
      document.querySelector('input[type="submit"]').removeAttribute('disabled')
    }

    setTimeout(() => {
      document.getElementById('error-duplicate-name').remove()
    }, (json.path && json.path !== '') ? 15000 : 5000);
  }

  validateField(event) {
    const input = event.target;
    const value = input.value;
    const oldValue = input.dataset.oldValue;
    const id = input.id;
    const error = document.querySelector(`#error-${id}`);
    if (value === "" && oldValue !== "") {
      error.classList.remove("d-none");
    } else {
      error.classList.add("d-none");
    }
  }

  validateFormSubmit(event) {
    const form = event.target;

    if (form.querySelector(".field-error:not(.d-none)")) {
      alert("Please take a look at the errors");
      event.detail.formSubmission.stop();
    }
  }
}
